module.exports = __webpack_public_path__ + "static/media/field-presentation-skills.9ce38ae3.svg";